import * as React from 'react'
import { FC } from 'react'

import { ENTITY_TYPES } from '@sales-center/common'
import { EntityValue } from './EntityValue'
import { ILead } from '@user/store/lead/typings'
import { IOpportunity } from '@user/store/opportunity/typings'
import { LEAD_STATUSES } from '@user/components/Leads/LeadCard/typings'
import { OPPORTUNITY_STATUSES } from '@user/components/Opportunities/OpportunityCard/typings'

import Box from '@mui/material/Box'

interface Props {
  detail: ILead | IOpportunity
  entityId: number
  entityStatus: LEAD_STATUSES | OPPORTUNITY_STATUSES
  entityType: ENTITY_TYPES
}

export const ContentRight: FC<Props> = (props) => {
  const { detail, entityStatus, entityType } = props

  return (
    <Box flexBasis="250px" textAlign="right">
      <EntityValue
        detail={detail}
        entityStatus={entityStatus}
        entityType={entityType}
      />
    </Box>
  )
}

ContentRight.displayName = 'ContentRight'
